const IowaBENInputHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return { filingState: '' };
  }

  switch (action.type) {
    case 'SELECT_EFILE_STATE':
      return Object.assign({}, state, {
        filingState: action.selectedState,
      });
    default:
      return state;
  }
};

export default IowaBENInputHandler;



// WEBPACK FOOTER //
// ./src-react/IowaBENInput/IowaBENInputReducer.jsx